"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleEnum = void 0;
var LocaleEnum;
(function (LocaleEnum) {
    LocaleEnum["en_US"] = "en-US";
    LocaleEnum["de_DE"] = "de-DE";
    LocaleEnum["hu_HU"] = "hu-HU";
    LocaleEnum["sq_AL"] = "sq-AL";
    LocaleEnum["hy_AM"] = "hy-AM";
    LocaleEnum["az_az"] = "az-az";
    LocaleEnum["be_BY"] = "be-BY";
    LocaleEnum["bs_Latn_BA"] = "bs-Latn-BA";
    LocaleEnum["bg_BG"] = "bg-BG";
    LocaleEnum["hr_HR"] = "hr-HR";
    LocaleEnum["ka_GE"] = "ka-GE";
    LocaleEnum["is_IS"] = "is-IS";
    LocaleEnum["ro_mo"] = "ro-mo";
    LocaleEnum["sr_sp"] = "sr-sp";
    LocaleEnum["uk_UA"] = "uk-UA";
    LocaleEnum["ja_JP"] = "ja-JP";
    LocaleEnum["en_GB"] = "en-GB";
    LocaleEnum["en_AU"] = "en-AU";
    LocaleEnum["en_CA"] = "en-CA";
    LocaleEnum["de_CH"] = "de-CH";
    LocaleEnum["zh_CN"] = "zh-CN";
    LocaleEnum["zh_HK"] = "zh-HK";
    LocaleEnum["en_NZ"] = "en-NZ";
    LocaleEnum["sv_SE"] = "sv-SE";
    LocaleEnum["ko_KR"] = "ko-KR";
    LocaleEnum["en_SG"] = "en-SG";
    LocaleEnum["nb_NO"] = "nb-NO";
    LocaleEnum["es_MX"] = "es-MX";
    LocaleEnum["hi_IN"] = "hi-IN";
    LocaleEnum["ru_RU"] = "ru-RU";
    LocaleEnum["en_ZA"] = "en-ZA";
    LocaleEnum["tr_TR"] = "tr-TR";
    LocaleEnum["pt_BR"] = "pt-BR";
    LocaleEnum["zh_TW"] = "zh-TW";
    LocaleEnum["da_DK"] = "da-DK";
    LocaleEnum["pl_PL"] = "pl-PL";
    LocaleEnum["th_TH"] = "th-TH";
    LocaleEnum["id_ID"] = "id-ID";
    LocaleEnum["cs_CZ"] = "cs-CZ";
    LocaleEnum["he_IL"] = "he-IL";
    LocaleEnum["es_CL"] = "es-CL";
    LocaleEnum["en_PH"] = "en-PH";
    LocaleEnum["ar_AE"] = "ar-AE";
    LocaleEnum["es_CO"] = "es-CO";
    LocaleEnum["ar_SA"] = "ar-SA";
    LocaleEnum["ms_MY"] = "ms-MY";
    LocaleEnum["ro_RO"] = "ro-RO";
    LocaleEnum["xh_ZA"] = "xh-ZA";
    LocaleEnum["en_KE"] = "en-KE";
    LocaleEnum["en_NG"] = "en-NG";
    LocaleEnum["es_AR"] = "es-AR";
})(LocaleEnum || (exports.LocaleEnum = LocaleEnum = {}));
